<template>
  <div class="support">
    <div class="w3-row">
      <div class="w3-col l8 animateUp">
        <div class="sectionHeader">
          <h5>Support</h5>
        </div>
        <div class="whiteContainer">
          FAQ's and more support options coming soon. Please use the contact form if you have questions or need assistance with your account as an advertiser or organizer. You may also use the contact form to report any bugs or issues with the site in general. We will respond to your request as soon as possible, usually within two business days. Thanks for using daytonalocal.com!
        </div>
        <div class="whiteContainer">
          If any content on the page has been copied from another source and you wish to have the content removed please use the contact form and include the link / url to the page in questions along with a link / url to the original content. Daytonalocal.com reserves the right to remove any event content that is found to be duplicate or copied from another source without permission.
        </div>
      </div>

      <!-- Sidebar -->
      <div class="w3-col l4 animateLeft">
        <div class="sectionHeader">
          <h5>Contact</h5>
        </div>
        <div class="whiteContainer">
          <input class="w3-input w3-border" v-model="contact.email" placeholder="Email" />
          <input class="w3-input w3-border" v-model="contact.subject" placeholder="Subject" />
          <textarea class="w3-input w3-border" v-model="contact.message" placeholder="Enter your message" />
          <template v-if="submitError !== ''">
            <p style="color:#c62828; text-align:center;">{{submitError}}</p>
          </template>
          <template v-if="submitSuccess">
            <p style="color:#43a047; text-align:center;">Successfully sent message</p>
          </template>
          <div class="w3-row">
            <div class="w3-col s6">
              <button class="w3-button w3-block w3-red" @click="clearForm()">Clear Form</button>
            </div>
            <div class="w3-col s6">
              <button class="w3-button w3-block w3-green" @click="sendMessage()" :disabled="contact.email === '' || contact.subject === '' || contact.message === ''">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'

export default {
  name: 'support',
  data() {
    return {
      contact: {
        email: '',
        subject: '',
        message: ''
      },
      submitError: '',
      submitSuccess: false
    }
  },
  methods: {
    sendMessage() {
      this.submitError = ''
      if (this.contact.email === '') {
        this.submitError = 'Please enter an Email Address'
        return
      }
      if (/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(this.contact.email)) {
        // ok email
        console.log('email ok')
      } else {
        this.submitError = 'Please enter a valid Email Address'
        return
      }
      if (this.contact.subject === '') {
        this.submitError = 'Please enter a Subject'
        return
      }
      if (this.contact.message === '') {
        this.submitError = 'Please enter a Message'
        return
      }
      axios.post('https://us-central1-daytona-local.cloudfunctions.net/contactEmail', this.contact).then((response) => {
        console.log(response)
        this.submitSuccess = true
        setTimeout(() => {
          this.submitSuccess = false
        }, 15000);
      }).catch(error => {
        console.log(error)
      })
    },
    clearForm() {
      this.submitError = ''
      this.submitSuccess = ''
      this.contact = {
        email: '',
        subject: '',
        message: ''
      }
    }
    // eventNav(event) {
    //   this.$router.push({ name: 'event-details', params: {event: event} })
    //   window.scrollTo(0, 0)
    // }
  }
}
</script>

<style scoped>
</style>
